import { render, staticRenderFns } from "./CFRubricPrintModal.vue?vue&type=template&id=46f849de&scoped=true"
import script from "./CFRubricPrintModal.vue?vue&type=script&lang=js"
export * from "./CFRubricPrintModal.vue?vue&type=script&lang=js"
import style0 from "./CFRubricPrintModal.vue?vue&type=style&index=0&id=46f849de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46f849de",
  null
  
)

export default component.exports